import { GraphQLClient } from 'graphql-request'
import { getSdk } from '@app/graphql/service/schema'
import { getSdk as getCmsSdk } from '@app/graphql/cms/schema'
import { getSdk as getProviderSdk } from '@app/graphql/provider/schema'

import { runtimeConfig } from '@app/common/config'

if (!runtimeConfig.API_ENDPOINT) {
  throw new Error('API_ENDPOINT not provided')
}

if (!runtimeConfig.API_ENDPOINT_GRAPH_CMS) {
  throw new Error('API_ENDPOINT_GRAPH_CMS not provided')
}

if (!runtimeConfig.API_ENDPOINT_PROVIDER) {
  throw new Error('API_ENDPOINT_PROVIDER not provided')
}

const options: GraphQLClient['options'] = {}

if (runtimeConfig.TEST_HEADER) {
  options.headers = {
    'Sprout-Environment': 'Test'
  }
}

export const apiSdk = getSdk(new GraphQLClient(runtimeConfig.API_ENDPOINT, options))
export const cmsSdk = getCmsSdk(new GraphQLClient(runtimeConfig.API_ENDPOINT_GRAPH_CMS))
export const providerSdk = getProviderSdk(
  new GraphQLClient(runtimeConfig.API_ENDPOINT_PROVIDER, {
    credentials: 'include',
    mode: 'cors'
  })
)
